import { mySRCMClient, myStaticProfileUpdateClient } from './HTTPClient';
import {
	MeProfile,
	MeProfilePage,
	StatesResponse,
	Language,
} from '../shared/MySrcm';
import {
	COUNTRY_CODE_INDIA_FOR_REGIONS,
	ME_PROFILE_FIELDS,
} from '../shared/Constants';
import { mySRCMBaseURL, xClientId } from './EnvService';
import { AxiosResponse } from 'axios';

/* eslint-disable */
export const getMeProfile = async () => {
	const { getSRCMProfile } = await import('hfn-oneauth/main');
	const response: AxiosResponse<MeProfile, any> = (await getSRCMProfile({
		srcmBaseURL: `${mySRCMBaseURL}/`,
		xClientId,
		queryParams: ME_PROFILE_FIELDS.join(','),
	})) as AxiosResponse<MeProfile, any>;
	return response.data;
};
/* eslint-enable */

export const getStates = async (): Promise<StatesResponse> => {
	const response = await mySRCMClient.get<StatesResponse>('states/');
	return response.data;
};

export const getCountryProfile = async (searchValue: string) => {
	const response = await mySRCMClient.get<MeProfilePage>(
		`countries/?page_size=200&name__icontains=${searchValue}`
	);
	return response.data;
};
export const getStateProfile = async (
	CountryValue: string | number,
	searchValue: string
) => {
	const response = await mySRCMClient.get<MeProfilePage>(
		`states/?country=${CountryValue}&page_size=200&name__icontains=${searchValue}`
	);
	return response.data;
};
export const getCityProfile = async (
	StateValue: number | string,
	searchValue: string | number
) => {
	const response = await mySRCMClient.get<MeProfilePage>(
		`cities/?state=${StateValue}&page_size=200&name__icontains=${searchValue}`
	);
	return response.data;
};

export const getZonesProfile = async () => {
	const response = await myStaticProfileUpdateClient.get<MeProfilePage>(
		'/groups/zone/all.json'
	);
	return response.data;
};

export const getCenterProfile = async (parentID: number, searchKey: string) => {
	const response = await mySRCMClient.get<MeProfilePage>(
		`/groups/?group_type=center&ancestor_group=${parentID}&page_size=200&name__icontains=${searchKey}`
	);
	return response.data;
};

export const getRegionsProfile = async () => {
	const response = await mySRCMClient.get<MeProfilePage>(
		`/groups/?ancestor_group=${COUNTRY_CODE_INDIA_FOR_REGIONS}&group_type=region`
	);
	return response.data;
};

export const getZonesByRegion = async (regionId: number) => {
	const response = await mySRCMClient.get<MeProfilePage>(
		`/groups/?ancestor_group=${regionId}&group_type=zone`
	);
	return response.data;
};

export const getLanguages = async (): Promise<{ results: Language[] }> => {
	const response = await mySRCMClient.get<{ results: Language[] }>(
		`/languages/?page_size=100`
	);
	return response.data;
};
